<template>
  <div id="app">
    <v-app id="inspire">
      <v-card v-model="show" color="#FFFF99">
        <v-card-title>
          <h6>SGI - Búsqueda de Documentos</h6>
        </v-card-title>
        <v-card-text class="pt-2">
          <v-row dense>
            <v-col cols="12" sm="12" md="6">
              <v-text-field label="Filtro por Código" dense v-model="filtrocod">
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-text-field label="Filtro por Nombre de Documento" dense v-model="filtrodoc">
              </v-text-field>
            </v-col>
          </v-row>

          <v-row align="center" justify="space-around">
            <v-btn tile color="success" @click="cargarListado(filtrocod, filtrodoc)">
              <v-icon left> mdi-magnify </v-icon>
              Buscar
            </v-btn>
          </v-row>
        </v-card-text>
      </v-card>
      <v-data-table dense :headers="headers" :items="listadodoc" locale="es-ar" class="elevation-1"
        :items-per-page="100" :footer-props="{
          itemsPerPageText: 'Documentos por página',
        }">
        <template v-slot:item.actions="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs" @click.stop="verInforme(item)">
                mdi-eye
              </v-icon>
            </template>
            <span>Ver Documento</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }" v-if="item.cod == 'EI 020'">
              <a target="_blank" :href="'https://api.icssa.com.ar/SGI/Documentos/EI 020.doc?' + Math.random()"><v-icon
                  small color="blue" class="mr-2" v-on="on" v-bind="attrs">
                  mdi-file-word
                </v-icon>
              </a>
            </template>
            <span>PPT</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }" v-if="item.cod == 'EI 020'">
              <a target="_blank" :href="'https://api.icssa.com.ar/SGI/Documentos/EI 020.ppt?' + Math.random()"><v-icon
                  small color="orange" class="mr-2" v-on="on" v-bind="attrs">
                  mdi-file-powerpoint
                </v-icon>
              </a>
            </template>
            <span>PPT</span>
          </v-tooltip>
        </template>
      </v-data-table>
      <Visualizardocumentos :visible="showInforme" :codigo="editedItem.cod" :nivel="editedItem.nivel" :rutadoc="rutadoc"
        @close="showInforme = false"></Visualizardocumentos>
    </v-app>
  </div>
</template>

<script>
import Visualizardocumentos from "./Visualizardocumento.vue";
import axios from "../../../src/axios-auth";
export default {
  data: (vm) => ({
    filtrodoc: "",
    filtrocod: "",
    listadodoc: [],
    editedItem: {},
    editedIndex: -1,
    headers: [
      { text: "Nivel", value: "nivel", sortable: false },
      { text: "Documento", value: "doc", width: "30%", sortable: false },
      { text: "Código", value: "cod", width: "15%", sortable: false },
      { text: "Ed.", value: "ed", sortable: false },
      { text: "Rev.", value: "rev", sortable: false },
      { text: "Fecha Rev.", value: "fecha", sortable: false },
      {
        text: "Originado en: (sólo nivel III y IV)",
        value: "origen",
        sortable: false,
      },
      { text: "Responsable", value: "resp", sortable: false },
      { text: "Código Clasific.", value: "clas", sortable: false },
      { text: "Tiempo (años)", value: "tiempo", sortable: false },
      { text: "Observaciones", value: "obs", sortable: false },
      { text: "Acciones", value: "actions", align: "center", sortable: false },
    ],
    showInforme: false,
    rutadoc: "",
  }),
  components: { Visualizardocumentos },
  computed: {
    show: {
      get() {
        this.cargarListado();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },

  methods: {
    verInforme(item) {
      this.editedIndex = this.listadodoc.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.showInforme = true;
    },

    cargarListado() {
      const filtrodoc = this.filtrodoc;
      const filtrocod = this.filtrocod;
      let self = this;
      axios
        .get("/Sgi/ListadoBuscarDoc?", {
          params: {
            filtrodoc: filtrodoc,
            filtrocod: filtrocod,
          },
        })
        .then((response) => {
          self.listadodoc = response.data;
        })
        .catch((error) => {
          self.listadodoc = [];
          console.log(error);
        });
    },
  },
};
</script>
